<template>
  <v-card max-height="600px" :dark="darkEnabled">
    <v-card-title class="pa-4">
      <span class="text-h5">Detalhamento</span>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-4 text-start">
      <span class="font-weight-bold">
        <span>
          Tabela de preços no momento do pedido:
        </span>
        {{ pedido.dadospedido.grupoPreco || "Sem tabela de preços" }}
      </span>
      <LineDivider />
      <v-alert
        type="info"
        color="indigo"
        class="mt-n4 mb-1"
        :dark="darkEnabled"
        v-if="pedido.pedidooriginal"
      >
        <span v-if="pedido.pedidooriginal === pedido.numpedido">
          Esse pedido originou os seguintes pedidos:
          <template
            v-if="pedido.pedidosquebrados && pedido.pedidosquebrados.length > 0"
          >
            <span v-for="(item, i) in pedido.pedidosquebrados" :key="i">
              <FormButton
                flat
                outlined
                class="font-weight-bold ml-3"
                @click="onClickBreak(item)"
              >
                {{ item }}
              </FormButton>
            </span>
          </template>
        </span>
        <span v-else>
          Esse pedido tem origem do desmembramento do pedido número:
          <FormButton
            flat
            outlined
            class="font-weight-bold"
            @click="onClickBreak(pedido.pedidooriginal)"
          >
            {{ pedido.pedidooriginal }}
          </FormButton>
        </span>
      </v-alert>
      <LineDivider />
      <v-row class="font-weight-bold" v-if="listItensOriginal.length > 0">
        <v-col cols="auto">
          Itens originais
        </v-col>
        <v-col>
          <FormField
            class="mt-n2 mb-n5"
            clearable
            v-model="searchItens"
            placeholder="Pesquisar por nome, código de barras ou código interno"
          ></FormField>
        </v-col>
        <v-col cols="auto">
          <v-icon
            v-if="showItensOriginais"
            class="float-right"
            @click="showItensOriginais = !showItensOriginais"
          >
            fa-chevron-up
          </v-icon>
          <v-icon
            v-else
            class="float-right"
            @click="showItensOriginais = !showItensOriginais"
          >
            fa-chevron-down
          </v-icon>
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <template v-if="showItensOriginais && listItensOriginal.length > 0">
          <v-col
            cols="12"
            md="4"
            v-for="(item, i) in (listItensOriginal || []).filter(
              item => item.tipo_produto !== 'SUBITEM'
            )"
            :key="i"
          >
            <v-card flat :dark="darkEnabled" :color="innerCardColor">
              <v-card-title>
                <h6 class="text-truncate">
                  <a
                    href="#"
                    @click="searchItens = item.nome || item.nome_combo"
                  >
                    {{ item.nome || item.nome_combo }}
                  </a>
                </h6>
              </v-card-title>
              <v-divider />
              <v-card-text class="pa-4">
                <p class="mb-0">
                  <span>Cód. barras: </span>
                  {{ item.codigobarras || "sem código de barras" }}
                </p>
                <p class="mb-0">
                  <span>Cod. interno: </span>
                  {{
                    item.id_erp ||
                      item.id_produto_erp ||
                      item.id_combopromocional_erp ||
                      "sem código interno"
                  }}
                </p>
                <p class="mb-0">
                  <span>Preço atual: </span>
                  R$ {{ item.preco || 0 }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" size="15" class="ml-1 mt-n1"
                        >far fa-question-circle</v-icon
                      >
                    </template>
                    Preço base: R$
                    {{
                      item.preco /
                        pedido.dadospedido.formaPagamento.fator_preco || 0
                    }}
                    <br />
                    <template v-if="item.preco_sem_politica_varejo"
                      >Preço (sem política): R$
                      {{ item.preco_sem_politica_varejo }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.precovendaatacado && item.precovendaatacado != '0'
                      "
                    >
                      Preço atacado: R$
                      {{ item.precovendaatacado }} <br />
                      Preço atacado base:
                      {{
                        item.precovendaatacado /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.preco_sem_politica_atacado &&
                          item.preco_sem_politica_atacado !== '0'
                      "
                    >
                      Preço atacado(sem política): R$
                      {{ item.preco_sem_politica_atacado }}
                      <br />
                    </template>
                  </v-tooltip>
                </p>
                <p class="mb-0">
                  <span>Preço base: </span>
                  R$
                  {{
                    item.preco /
                      pedido.dadospedido.formaPagamento.fator_preco || 0
                  }}
                </p>
                <p class="mb-0">
                  <span>Quantidade: </span>
                  {{ item.quantidade }}
                </p>
                <p class="mb-0">
                  <span>Múltiplo: </span>
                  {{ item.multiploincremento }}
                </p>
                <p class="mb-0">
                  <span>Total: </span>
                  {{ (item.quantidade * item.preco) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_embalagem">
                  <span>Total embalagem: </span>
                  {{ (item.quantidade * item.preco_embalagem) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_do_desconto">
                  <span>Desconto do cupom: </span>
                  {{ (item.quantidade * item.preco_do_desconto) | formatMoney }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>Política: </span>
                  {{ getPolitica(item).descricao }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>
                    Fator de preço da política:
                  </span>
                  <span v-if="getPolitica(item).fatorPreco">{{
                    getPolitica(item).fatorPreco
                  }}</span>
                  <span v-else>
                    {{
                      getFatorDescontoProgressivo(
                        getPolitica(item).descontosProgressivos,
                        item.quantidade
                      )
                    }}
                  </span>
                </p>
                <p
                  class="mb-0"
                  v-if="
                    getPolitica(item) &&
                      getPolitica(item).ignorarFatorFormaPagamento
                  "
                >
                  <span>
                    Fator de preço da forma de pagamento:
                  </span>
                  Ignorado devido à política
                </p>
                <p class="mb-0" v-if="item.deleted">
                  <span class="red--text">
                    Removido
                  </span>
                </p>
                <template class="mb-0" v-if="item.produtos">
                  <p class="mb-1">
                    Produtos do combo
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in item.produtos"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
                <template
                  class="mb-0"
                  v-if="
                    (listItensOriginal || []).filter(
                      item => item.tipo_produto === 'SUBITEM'
                    ).length > 0
                  "
                >
                  <p class="mb-1">
                    Produtos do conjunto
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in (listItensOriginal || []).filter(
                      subitem =>
                        subitem.tipo_produto === 'SUBITEM' &&
                        subitem.idcadastroextrabase === item.idcadastroextra
                    )"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <LineDivider v-if="showItensOriginais && listItensOriginal.length > 0" />
      <v-row class="font-weight-bold">
        <v-col>
          Itens integrados
        </v-col>
        <v-col>
          <v-icon
            v-if="showItens"
            class="float-right"
            @click="showItens = !showItens"
          >
            fa-chevron-up
          </v-icon>
          <v-icon v-else class="float-right" @click="showItens = !showItens">
            fa-chevron-down
          </v-icon>
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <template v-if="showItens && listItens.length > 0">
          <v-col
            cols="12"
            md="4"
            v-for="(item, i) in (listItens || []).filter(
              item => item.tipo_produto !== 'SUBITEM'
            )"
            :key="i"
          >
            <v-card flat :dark="darkEnabled" :color="innerCardColor">
              <v-card-title>
                <h6 class="text-truncate">
                  <a
                    href="#"
                    @click="searchItens = item.nome || item.nome_combo"
                  >
                    {{ item.nome || item.nome_combo }}
                  </a>
                </h6>
              </v-card-title>
              <v-divider />
              <v-card-text class="pa-4">
                <p class="mb-0">
                  <span>Cód. barras: </span>
                  {{ item.codigobarras || "sem código de barras" }}
                </p>
                <p class="mb-0">
                  <span>Cod. interno: </span>
                  {{
                    item.id_erp ||
                      item.id_produto_erp ||
                      item.id_combopromocional_erp ||
                      "sem código interno"
                  }}
                </p>
                <p class="mb-0">
                  <span>Preço atual: </span>
                  R$ {{ item.preco || 0 }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" size="15" class="ml-1 mt-n1"
                        >far fa-question-circle</v-icon
                      >
                    </template>
                    Preço base: R$
                    {{
                      item.preco /
                        pedido.dadospedido.formaPagamento.fator_preco || 0
                    }}
                    <br />
                    <template v-if="item.preco_sem_politica_varejo"
                      >Preço (sem política): R$
                      {{ item.preco_sem_politica_varejo }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.precovendaatacado && item.precovendaatacado != '0'
                      "
                    >
                      Preço atacado: R$
                      {{ item.precovendaatacado }} <br />
                      Preço atacado base:
                      {{
                        item.precovendaatacado /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.preco_sem_politica_atacado &&
                          item.preco_sem_politica_atacado !== '0'
                      "
                    >
                      Preço atacado(sem política): R$
                      {{ item.preco_sem_politica_atacado }}
                      <br />
                    </template>
                  </v-tooltip>
                </p>
                <p class="mb-0">
                  <span>Preço base: </span>
                  R$
                  {{
                    item.preco /
                      pedido.dadospedido.formaPagamento.fator_preco || 0
                  }}
                </p>
                <p class="mb-0">
                  <span>Quantidade: </span>
                  {{ item.quantidade }}
                </p>
                <p class="mb-0">
                  <span>Múltiplo: </span>
                  {{ item.multiploincremento }}
                </p>
                <p class="mb-0">
                  <span>Total: </span>
                  {{ (item.quantidade * item.preco) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_embalagem">
                  <span>Total embalagem: </span>
                  {{ (item.quantidade * item.preco_embalagem) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_do_desconto">
                  <span>Desconto do cupom: </span>
                  {{ (item.quantidade * item.preco_do_desconto) | formatMoney }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>Política: </span>
                  {{ getPolitica(item).descricao }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>
                    Fator de preço da política:
                  </span>
                  <span v-if="getPolitica(item).fatorPreco">{{
                    getPolitica(item).fatorPreco
                  }}</span>
                  <span v-else>
                    {{
                      getFatorDescontoProgressivo(
                        getPolitica(item).descontosProgressivos,
                        item.quantidade
                      )
                    }}
                  </span>
                </p>
                <p
                  class="mb-0"
                  v-if="
                    getPolitica(item) &&
                      getPolitica(item).ignorarFatorFormaPagamento
                  "
                >
                  <span>
                    Fator de preço da forma de pagamento:
                  </span>
                  Ignorado devido à política
                </p>
                <p class="mb-0" v-if="item.deleted">
                  <span class="red--text">
                    Removido
                  </span>
                </p>
                <template v-if="item.produtos">
                  <p class="mb-1">
                    Produtos do combo
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in item.produtos"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
                <template
                  class="mb-0"
                  v-if="
                    (listItens || []).filter(
                      item => item.tipo_produto === 'SUBITEM'
                    ).length > 0
                  "
                >
                  <p class="mb-1">
                    Produtos do conjunto
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in (listItens || []).filter(
                      subitem =>
                        subitem.tipo_produto === 'SUBITEM' &&
                        subitem.idcadastroextrabase === item.idcadastroextra
                    )"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
        <v-col class="text-center" v-if="showItens && listItens.length <= 0">
          Nenhum produto encontrado.
        </v-col>
      </v-row>
      <LineDivider v-if="showItens" />
      <v-row class="font-weight-bold" v-if="listItensCortados.length > 0">
        <v-col>
          Itens cortados
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon size="18" v-on="on" class="ml-3">
                far fa-question-circle
              </v-icon>
            </template>
            Os produtos são exibidos nessa seção quando foram cortados, contém
            restrições e/ou o pedido teve algum erro de integração!
          </v-tooltip>
        </v-col>
        <v-col>
          <v-icon
            v-if="showItensCortados"
            class="float-right"
            @click="showItensCortados = !showItensCortados"
          >
            fa-chevron-up
          </v-icon>
          <v-icon
            v-else
            class="float-right"
            @click="showItensCortados = !showItensCortados"
          >
            fa-chevron-down
          </v-icon>
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <template v-if="showItensCortados && listItensCortados.length > 0">
          <v-col
            cols="12"
            md="4"
            v-for="(item, i) in (listItensCortados || []).filter(
              item => item.tipo_produto !== 'SUBITEM'
            )"
            :key="i"
          >
            <v-card flat :dark="darkEnabled" :color="innerCardColor">
              <v-card-title>
                <h6 class="text-truncate">
                  <a
                    href="#"
                    @click="searchItens = item.nome || item.nome_combo"
                  >
                    {{ item.nome || item.nome_combo }}
                  </a>
                </h6>
              </v-card-title>
              <v-divider />
              <v-card-text class="pa-4">
                <p class="mb-0">
                  <span>Cód. barras: </span>
                  {{ item.codigobarras || "sem código de barras" }}
                </p>
                <p class="mb-0">
                  <span>Cod. interno: </span>
                  {{
                    item.id_erp ||
                      item.id_produto_erp ||
                      item.id_combopromocional_erp ||
                      "sem código interno"
                  }}
                </p>
                <p class="mb-0">
                  <span>Preço atual: </span>
                  R$ {{ item.preco || 0 }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" size="15" class="ml-1 mt-n1"
                        >far fa-question-circle</v-icon
                      >
                    </template>
                    Preço base: R$
                    {{
                      item.preco /
                        pedido.dadospedido.formaPagamento.fator_preco || 0
                    }}
                    <br />
                    <template v-if="item.preco_sem_politica_varejo"
                      >Preço (sem política): R$
                      {{ item.preco_sem_politica_varejo }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.precovendaatacado && item.precovendaatacado != '0'
                      "
                    >
                      Preço atacado: R$
                      {{ item.precovendaatacado }} <br />
                      Preço atacado base:
                      {{
                        item.precovendaatacado /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                      <br />
                    </template>
                    <template
                      v-if="
                        item.preco_sem_politica_atacado &&
                          item.preco_sem_politica_atacado !== '0'
                      "
                    >
                      Preço atacado(sem política): R$
                      {{ item.preco_sem_politica_atacado }}
                      <br />
                    </template>
                  </v-tooltip>
                </p>
                <p class="mb-0">
                  <span>Preço base: </span>
                  R$
                  {{
                    item.preco /
                      pedido.dadospedido.formaPagamento.fator_preco || 0
                  }}
                </p>
                <p class="mb-0">
                  <span>Quantidade: </span>
                  {{ item.quantidade }}
                </p>
                <p class="mb-0">
                  <span>Múltiplo: </span>
                  {{ item.multiploincremento }}
                </p>
                <p class="mb-0">
                  <span>Total: </span>
                  {{ (item.quantidade * item.preco) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_embalagem">
                  <span>Total embalagem: </span>
                  {{ (item.quantidade * item.preco_embalagem) | formatMoney }}
                </p>
                <p class="mb-0" v-if="item.preco_do_desconto">
                  <span>Desconto do cupom: </span>
                  {{ (item.quantidade * item.preco_do_desconto) | formatMoney }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>Política: </span>
                  {{ getPolitica(item).descricao }}
                </p>
                <p
                  class="mb-0"
                  v-if="getPolitica(item) && getPolitica(item).descricao"
                >
                  <span>
                    Fator de preço da política:
                  </span>
                  <span v-if="getPolitica(item).fatorPreco">{{
                    getPolitica(item).fatorPreco
                  }}</span>
                  <span v-else>
                    {{
                      getFatorDescontoProgressivo(
                        getPolitica(item).descontosProgressivos,
                        item.quantidade
                      )
                    }}
                  </span>
                </p>
                <p
                  class="mb-0"
                  v-if="
                    getPolitica(item) &&
                      getPolitica(item).ignorarFatorFormaPagamento
                  "
                >
                  <span>
                    Fator de preço da forma de pagamento:
                  </span>
                  Ignorado devido à política
                </p>
                <p class="mb-0" v-if="item.deleted">
                  <span class="red--text">
                    Removido
                  </span>
                </p>
                <template class="mb-0" v-if="item.produtos">
                  <p class="mb-1">
                    Produtos do combo
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in item.produtos"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
                <template
                  class="mb-0"
                  v-if="
                    (listItensCortados || []).filter(
                      item => item.tipo_produto === 'SUBITEM'
                    ).length > 0
                  "
                >
                  <p class="mb-1">
                    Produtos do conjunto
                  </p>
                  <div
                    class="mb-1 pa-2"
                    :class="comboSectionClass"
                    style="border-radius: 8px;"
                    v-for="(p, ip) in (listItensCortados || []).filter(
                      subitem =>
                        subitem.tipo_produto === 'SUBITEM' &&
                        subitem.idcadastroextrabase === item.idcadastroextra
                    )"
                    :key="ip"
                  >
                    <p class=" mb-0">
                      {{ p.nome }}
                    </p>
                    <p class="mb-0">
                      Cód. barras:
                      {{ p.codigoBarra || "sem código de barras" }}
                    </p>
                    <p class="mb-0">
                      Cód. interno:
                      {{ p.id_erp || p.id_produto_erp || "sem código interno" }}
                    </p>
                    <p class="mb-0">Preço atual: R$ {{ p.preco || 0 }}</p>
                    <p class="mb-0">
                      Preço base: R$
                      {{
                        p.preco /
                          pedido.dadospedido.formaPagamento.fator_preco || 0
                      }}
                    </p>
                    <p class="mb-0">
                      Quantidade:
                      {{ p.quantidade }}
                    </p>
                    <p
                      class="mb-0"
                      v-if="p.multiploincremento && p.multiploincremento != 1"
                    >
                      Múltiplo:
                      {{ p.multiploincremento }}
                    </p>
                    <p class="mb-0">
                      Total:
                      {{ (p.preco * p.quantidade) | formatMoney }}
                    </p>
                    <p class="mb-0" v-if="p.preco_embalagem">
                      Total embalagem:
                      {{ (p.preco_embalagem * p.quantidade) | formatMoney }}
                    </p>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
      <LineDivider v-if="showItensCortados && listItensCortados.length > 0" />
      <v-row v-if="pedido.dadospedido && pedido.dadospedido.formaPagamento">
        <v-col cols="12" class="font-weight-bold">
          Forma de pagamento
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <p class="mb-0">
            <span class="font-weight-bold">
              Descrição:
            </span>
            {{ pedido.dadospedido.formaPagamento.descricao }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Fator preço:
            </span>
            {{ pedido.dadospedido.formaPagamento.fator_preco }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Quantidade de parcelas:
            </span>
            {{ pedido.dadospedido.formaPagamento.quantParcelas }}
          </p>
        </v-col>
      </v-row>
      <LineDivider
        v-if="pedido.dadospedido && pedido.dadospedido.formaPagamento"
      />
      <v-row v-if="pedido && pedido.forma_entrega">
        <v-col cols="12" class="font-weight-bold">
          Forma de entrega
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <p class="mb-0">
            <span class="font-weight-bold">
              Nome:
            </span>
            {{ pedido.forma_entrega.nome }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Custo:
            </span>
            {{ pedido.forma_entrega.custo | formatMoney }}
          </p>
          <p
            class="mb-0"
            v-if="
              pedido.forma_entrega.custo !=
                pedido.forma_entrega.custo_final_entrega
            "
          >
            <span class="font-weight-bold">
              Custo final entrega:
            </span>
            {{ pedido.forma_entrega.custo_final_entrega | formatMoney }}
          </p>
        </v-col>
      </v-row>
      <LineDivider v-if="pedido.dadospedido && pedido.forma_entrega" />
      <v-row v-if="pedido.cupom_pedido">
        <v-col cols="12" class="font-weight-bold">
          Descontos
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <p class="mb-0">
            <span class="font-weight-bold">
              Código do cupom:
            </span>
            {{ pedido.cupom_pedido.codigocupom }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Desconto cupom:
            </span>
            {{
              this.pedido.cupom_pedido.tipodesconto === "$"
                ? `R$ ${this.pedido.cupom_pedido.valordesconto}`
                : this.pedido.cupom_pedido.valordesconto +
                  this.pedido.cupom_pedido.tipodesconto
            }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Total de desconto:
            </span>
            {{ pedido.totaldescontocupom | formatMoney }}
          </p>
          <p
            class="mb-0"
            v-if="
              pedido.dadospedido &&
                pedido.dadospedido.originalDesconto &&
                pedido.dadospedido.originalDesconto.totaldesconto
            "
          >
            <span class="font-weight-bold">
              Total de desconto original:
            </span>
            {{
              pedido.dadospedido.originalDesconto.totaldesconto | formatMoney
            }}
          </p>
        </v-col>
      </v-row>
      <LineDivider v-if="pedido.cupom_pedido" />
      <v-row>
        <v-col cols="12" class="font-weight-bold">
          Totais
        </v-col>
        <v-col cols="12" class="pa-0 px-3">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <p class="mb-0">
            <span class="font-weight-bold">
              Total em compras:
            </span>
            {{ pedido.totalpedido | formatMoney }}
          </p>
          <p class="mb-0">
            <span class="font-weight-bold">
              Total à pagar:
            </span>
            {{ pedido.totalliquido | formatMoney }}
          </p>
          <p
            class="mb-0"
            v-if="showItensOriginais && listItensOriginal.length > 0"
          >
            <span class="font-weight-bold">
              Total original:
            </span>
            {{ totalOriginalItens | formatMoney }}
          </p>
          <p
            class="mb-0"
            v-if="showItensCortados && listItensCortados.length > 0"
          >
            <span class="font-weight-bold">
              Total itens cortados:
            </span>
            {{ totalItensCortados | formatMoney }}
          </p>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider />
    <slot></slot>
  </v-card>
</template>

<script>
import LineDivider from "@/components/LineDivider";
import FormField from "@/components/form/FormField";
import FormButton from "@/components/form/FormButton";
import locationsMixin from "@/mixins/locations";
import * as _ from "lodash";
import { mapGetters } from "vuex";
import { formatarCombos } from "../../../../utils/combo";

export default {
  name: "PedidoDetalhamento",
  mixins: [locationsMixin],
  components: {
    LineDivider,
    FormField,
    FormButton
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showItens: true,
    showItensOriginais: true,
    showItensCortados: true,
    searchItens: ""
  }),
  computed: {
    ...mapGetters(["darkEnabled"]),
    innerCardColor() {
      return this.darkEnabled ? "grey darken-4" : "blue-grey lighten-5";
    },
    comboSectionClass() {
      return this.darkEnabled ? "grey darken-3" : "blue-grey lighten-3";
    },
    politicas() {
      let politica = this.pedido.dadospedido.politicas || null;
      if (politica) {
        politica = politica.map(p => {
          const descontoProgressivo =
            (p.entao || []).filter(e => e.key === "desconto_progressivo")[0] ||
            {};
          const descontosProgressivos =
            _.get(descontoProgressivo, "value.politicas") || null;
          let fatorPreco = 0;
          if (!descontosProgressivos) {
            fatorPreco = (p.entao || []).filter(
              e => e.key === "indice_preco"
            )[0];
          }
          const anotacaoDestaque = (p.entao || []).filter(
            e => e.key === "anotacao_destaque"
          )[0];
          return {
            fatorPreco: _.get(fatorPreco, "value") || 0,
            descricao: p.descricao || _.get(anotacaoDestaque, "value") || "",
            idcadastroextraproduto: p.idcadastroextraproduto,
            ignorarFatorFormaPagamento: p.ignorarFatorFormaPagamento,
            descontosProgressivos
          };
        });
        return politica;
      }
      return null;
    },
    itens() {
      return this.pedido.dadospedido && this.pedido.dadospedido.itens
        ? this.pedido.dadospedido.itens
        : [];
    },
    itensCombo() {
      let itemsCombo = [];
      if (this.pedido.dadospedido && this.pedido.dadospedido.itensFormatCombo) {
        itemsCombo = formatarCombos(
          this.pedido.dadospedido.itensFormatCombo,
          this.itens
        );
      }

      return itemsCombo;
    },
    originalItens() {
      return this.pedido.dadospedido && this.pedido.dadospedido.originalItens
        ? this.pedido.dadospedido.originalItens
        : [];
    },
    itensCortados() {
      return this.pedido.dadospedido && this.pedido.dadospedido.itensCortados
        ? this.pedido.dadospedido.itensCortados
        : [];
    },
    listItens() {
      const search = (this.searchItens || "").toUpperCase();
      return this.itens
        .filter(i => i.id_combo_item === null)
        .concat(this.itensCombo)
        .filter(
          item =>
            (item.nome && item.nome.toUpperCase().includes(search)) ||
            (item.nome_combo &&
              item.nome_combo.toUpperCase().includes(search)) ||
            (item.id_erp && item.id_erp.toUpperCase().includes(search)) ||
            (item.id_combopromocional_erp &&
              item.id_combopromocional_erp.toUpperCase().includes(search)) ||
            (item.codigobarras &&
              item.codigobarras.toUpperCase().includes(search))
        );
    },
    totalOriginalItens() {
      const originalItens =
        this.originalItens && Array.isArray(this.originalItens)
          ? this.originalItens
          : [];
      return originalItens
        .filter(item => item.tipo_produto !== "CONJUNTO")
        .reduce((acc, item) => {
          return acc + item.preco * item.quantidade;
        }, 0)
        .toFixed(2);
    },
    listItensOriginal() {
      const search = (this.searchItens || "").toUpperCase();
      const originalItens =
        this.originalItens && Array.isArray(this.originalItens)
          ? this.originalItens
          : [];
      const itensCombo =
        this.pedido.dadospedido && this.pedido.dadospedido.itensFormatCombo
          ? this.pedido.dadospedido.itensFormatCombo.filter(
              c => c.produtos && c.produtos.length > 0
            )
          : [];
      return originalItens
        .filter(i => i.id_combo_item === null)
        .concat(itensCombo)
        .filter(
          item =>
            (item.nome && item.nome.toUpperCase().includes(search)) ||
            (item.nome_combo &&
              item.nome_combo.toUpperCase().includes(search)) ||
            (item.id_erp && item.id_erp.toUpperCase().includes(search)) ||
            (item.id_combopromocional_erp &&
              item.id_combopromocional_erp.toUpperCase().includes(search)) ||
            (item.codigobarras &&
              item.codigobarras.toUpperCase().includes(search))
        );
    },
    totalItensCortados() {
      const itensCortados =
        this.itensCortados && Array.isArray(this.itensCortados)
          ? this.itensCortados
          : [];
      return itensCortados.reduce((acc, item) => {
        return acc + item.preco * item.quantidade;
      }, 0);
    },
    listItensCortados() {
      const search = (this.searchItens || "").toUpperCase();
      const itensCortados =
        this.itensCortados && Array.isArray(this.itensCortados)
          ? this.itensCortados
          : [];
      return itensCortados.filter(
        item =>
          (item.nome && item.nome.toUpperCase().includes(search)) ||
          (item.nome_combo && item.nome_combo.toUpperCase().includes(search)) ||
          (item.id_erp && item.id_erp.toUpperCase().includes(search)) ||
          (item.id_combopromocional_erp &&
            item.id_combopromocional_erp.toUpperCase().includes(search)) ||
          (item.codigobarras &&
            item.codigobarras.toUpperCase().includes(search))
      );
    }
  },
  methods: {
    onClickBreak(item) {
      const url = this.$router.resolve({
        path: `/fornecedor/pedidos/detalhes/${item}`
      }).href;
      window.open(url, "_blank");
    },
    getPolitica(produto) {
      const politica = (this.politicas || []).find(
        p => p.idcadastroextraproduto === produto.idcadastroextra
      ) || {
        fatorPreco: 0,
        anotacaoDestaque: "",
        idcadastroextraproduto: ""
      };
      return politica;
    },
    getFatorDescontoProgressivo(descontosProgressivos, qtd = "") {
      if (descontosProgressivos) {
        const keys = Object.keys(descontosProgressivos);
        let key;
        if (!key) {
          keys.forEach(k => {
            if (k <= qtd) {
              key = qtd;
            }
          });
        }
        return _.get(descontosProgressivos, `${key}.value`) || "-";
      }
      return "";
    }
  }
};
</script>
